import * as styles from "./styles";

export const Brand = () => {
  return (
    <div css={styles.container}>
      <h4 css={styles.introductionTitle}>おかえり</h4>

      <p css={styles.introductionDescription}>
        ひとは、ひととのつながりで
        <br />
        自分をつくるんだって。
        <br />
        ひととの境目が、自分の輪郭なんだって。
        <br />
        つまり、わたしが、わたしであるのは、
        <br />
        みんなのおかげです。
        <br />
        みんなの反応で、自分を知ることができる。
        <br />
        思っても見なかった自分が顔をのぞかせることもある。
        <br />
        そんな自分こそ、ほんとの自分かも。
        <br />
        意外に寂しがり屋。
        <br />
        意外に真面目。
        <br />
        意外におしゃべり。
        <br />
        意外にミーハー。
        <br />
        ふわっちは、素顔のわたしにかえる場所。
        <br />
        おかえり、わたし。
        <br />
        会いたかったぞ。
      </p>

      <p css={styles.subDescription}>
        飾らない場所。飾らないわたし。
        <br />
        みんなのライブ配信
      </p>

      <h4 css={styles.endTitle}>ふわっち</h4>
    </div>
  );
};
